import fetchApi from 'services/api/connector';

//
// CHANGE PASSWORD section
//
/* eslint-disable import/prefer-default-export */
export const changePassword = (password, new_password, new_password_confirm) => fetchApi('change', { version: 'v1', method: 'POST', data: { password, new_password, new_password_confirm } });
